import { api } from "./config.js";

const landingApi = {
  getCategories: async (authToken) => {
    try {
      const headers = authToken ? { Authorization: `Bearer ${authToken}` } : {};
      const response = await api.get("/setting/getCategories", { headers });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get categories without auth (for public registration)
  getCategoriesPublic: async () => {
    try {
      const response = await api.get("/setting/getCategories");
      console.log("[DEBUG] getCategoriesPublic API response.status:", response.status);
      console.log("[DEBUG] getCategoriesPublic API response.data type:", typeof response.data);
      console.log("[DEBUG] getCategoriesPublic API response.data:", JSON.stringify(response.data).substring(0, 500));
      return response.data;
    } catch (error) {
      console.error("[DEBUG] getCategoriesPublic API error:", error.message, error.response?.status);
      throw error;
    }
  },

  getDistricts: async () => {
    try {
      const response = await api.get("/setting/getDistricts");
      console.log("[DEBUG] getDistricts API response.status:", response.status);
      console.log("[DEBUG] getDistricts API response.data type:", typeof response.data);
      console.log("[DEBUG] getDistricts API response.data:", JSON.stringify(response.data).substring(0, 500));
      return response.data;
    } catch (error) {
      console.error("[DEBUG] getDistricts API error:", error.message, error.response?.status);
      throw error;
    }
  },

  loginMerchant: async (phone, password) => {
    try {
      const response = await api.post("/merchant/login", {
        phone,
        password,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  fetchPlans: async () => {
    try {
      const response = await api.get("/setting/getplans");
      return response.data;
    } catch (error) {
      console.error("Error fetching plans:", error);
      throw error;
    }
  },

  getPlans: async (authToken) => {
    try {
      const response = await api.get("/merchant/getPlans/1", {
        headers: {
          Authorization: `Bearer ${authToken}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  fetchAddons: async () => {
    try {
      const response = await api.get("/setting/getaddons");
      return response.data;
    } catch (error) {
      console.error("Error fetching addons:", error);
      throw error;
    }
  },

  addPlan: async (merchant_id, planData, authToken) => {
    try {
      const response = await api.post(
        `/merchant/addPlan/${merchant_id}`,
        planData,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      console.error("Error adding plan:", error);
      throw error;
    }
  },

  addAddon: async (merchant_id, addonData, authToken) => {
    try {
      const response = await api.post(
        `/merchant/addAddon/${merchant_id}`,
        addonData,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      console.error("Error adding addon:", error);
      throw error;
    }
  },

  registerMerchant: async (formData) => {
    try {
      const response = await api.post("/merchant/merchantregister", {
        username: formData.username,
        shopname: formData.shopname,
        businessname: formData.businessname,
        email: formData.email,
        phone: formData.phone,
        district_id: formData.district_id,
        township_id: formData.township_id,
        password: formData.password,
        password_confirmation: formData.password_confirmation,
        category_id: formData.category_id,
        sub_category_id: formData.sub_category_id,
      });
      return response;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }
      throw new Error("Network error. Please try again.");
    }
  },

  getTownships: async (districtId) => {
    try {
      const response = await api.get(
        `/setting/getTownships?district_id=${districtId}`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  addBillingInformation: async (merchantId, billingData, authToken) => {
    try {
      const response = await api.post(
        `merchant/addBillingInformation/${merchantId}`,
        billingData,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        if (error.response.status === 403) {
          throw new Error("Unauthorized to use this merchant");
        }
        throw error.response.data;
      }
      throw error;
    }
  },

  addCardInformation: async (merchantId, cardData, authToken) => {
    try {
      const res = await api.post(
        `merchant/addCardInformation/${merchantId}`,
        cardData,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  processPayment: async (merchantId, paymentData, authToken) => {
    try {
      const res = await api.post("payment/create", paymentData, {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  getCountries: async (authToken) => {
    try {
      const headers = authToken ? { Authorization: `Bearer ${authToken}` } : {};
      const response = await api.get("/setting/getCountries", { headers });
      return response.data;
    } catch (error) {
      console.error("Error fetching countries:", error);
      throw error;
    }
  },

  showCountry: async (authToken, countryId) => {
    try {
      const res = await api.get(`/setting/showCountry?id=${countryId}`, {
        headers: {
          ...(authToken ? { Authorization: `Bearer ${authToken}` } : {}),
          "Content-Type": "application/json",
        },
      });
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  clientRegister: async (authToken, clientData) => {
    try {
      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        ...(authToken ? { Authorization: `Bearer ${authToken}` } : {}),
      };
      const res = await api.post("/client/register", clientData, { headers });
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  loginWithPhone: async (token, payload) => {
    const response = await api.post(
      "client/loginWithPhone",
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  },

  // createMemberCardPayment: async (paymentData, authToken) => {
  //   try {
  //     const res = await api.post("payment/create", paymentData, {
  //       headers: {
  //         Authorization: `Bearer ${authToken}`,
  //         "Content-Type": "application/json",
  //         Accept: "application/json",
  //       },
  //     });
  //     return res.data;
  //   } catch (error) {
  //     throw error;
  //   }
  // },
};

export { landingApi };
